export default function toArray(value) {
  return value == null ? [] : [].concat(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/yup/es/util/toArray.js
// module id = 206
// module chunks = 14